<script lang="ts">
  import Steps from "./Steps.svelte";
</script>

<Steps>
  <img
    class="step-check-img"
    slot="email-check"
    src="./assets/check-6aa942.png"
    alt="check-6aa942"
  />
  <img
    class="step-img"
    slot="email"
    src="./assets/email-6bab43.png"
    alt="email-6bab43"
  />

  <img
    class="step-check-img"
    slot="password-check"
    src="./assets/check-d7d7d7.png"
    alt="check-d7d7d7"
  />
  <img
    class="step-img"
    slot="password"
    src="./assets/password-c9c9c9.png"
    alt="password-c9c9c9"
  />

  <img
    class="step-check-img"
    slot="login-check"
    src="./assets/check-d7d7d7.png"
    alt="check-d7d7d7"
  />
  <img
    class="step-img"
    slot="login"
    src="./assets/login-c9c9c9.png"
    alt="login-c9c9c9"
  />
</Steps>

<style scoped>
  @media only screen and (max-width: 600px) {
    .step-check-img {
      width: 2.3rem;
    }
    .step-img {
      width: 4rem;
    }
  }
</style>
